<template>
    <div class="w-full flex flex-wrap justify-center">
        <div class="hidden">
            <i class="fad fa-share-alt"></i>
            Share
        </div>

        <ShareNetwork
            @close="onShared"
            v-for="network in networks"
            :network="network.network"
            :key="network.network"
            :url="sharing.url"
            :title="sharing.title"
            :description="sharing.description"
            :hashtags="sharing.hashtags"
            :twitterUser="sharing.twitterUser"
            :style="{backgroundColor: network.color}"
            class="btn btn-sm mr-0 sm:mr-1 mb-2 w-1/2 sm:w-auto text-white hover:text-white"
        >
            <!-- <fa-icon :icon="network.icon" class="fah fa-lg mr-2" /> -->
            <i :class="network.icon" class="fah fa-lg mr-2"></i>
            <span class="mt-2 font-semibold">
                {{ network.name }}
            </span>
        </ShareNetwork>
    </div>
</template>

<script>
/**
 * @todo when supporting CN region, show baidu and wechat
 * @see https://github.com/nicolasbeauvais/vue-social-sharing
 * @see https://www.addthis.com/social-buttons/
 * @see https://sharethis.com
 */
export default {
    props: [
        'page-url',
        'title',
        'description'
    ],

    data: () => ({
        sharing: {
            url: '',
            title: '',
            description: ''
            // hashtags: 'tag1,tag2',
            // twitterUser: 'namepromo1'
        },
        networks: [
            { network: 'email', name: 'Email', icon: 'far fa-envelope', color: '#333333' },
            { network: 'sms', name: 'SMS', icon: 'far fa-comment-dots', color: '#09be41' },
            { network: 'facebook', name: 'Facebook', icon: 'fab fa-facebook-f', color: '#1877f2' },
            { network: 'twitter', name: 'Twitter', icon: 'fab fa-twitter', color: '#1da1f2' },
            { network: 'reddit', name: 'Reddit', icon: 'fab fa-reddit-alien', color: '#ff4500' },
            { network: 'whatsapp', name: 'Whatsapp', icon: 'fab fa-whatsapp', color: '#25d366' },
            { network: 'telegram', name: 'Telegram', icon: 'fab fa-telegram-plane', color: '#0088cc' },
            { network: 'skype', name: 'Skype', icon: 'fab fa-skype', color: '#00aff0' },
            { network: 'linkedin', name: 'LinkedIn', icon: 'fab fa-linkedin', color: '#007bb5' },
            { network: 'pinterest', name: 'Pinterest', icon: 'fab fa-pinterest', color: '#bd081c' }
        ]
    }),

    created() {
        // Vue.$root.$on('share_network_close', function (network, url) {});

        this.sharing.url = this.pageUrl || window.location.href;
        this.sharing.title = this.title;
        this.sharing.description = this.description;
    },

    methods: {
        onShared(network, url) {
            this.trackRawEvent('share', {
                network : network,
                url     : url
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.btn {
    color: #fff;

    &:hover {
        color: #fff;
    }
    svg {
        // background-color: rgba(0, 0, 0, 0.2);
    }
}
</style>
